// global js
import $ from 'jquery'
import _ from 'underscore'
import _str from 'underscore.string'
import Backbone from '@polleverywhere/backbone'
import URI from 'urijs'
import XDate from 'xdate'

window.jQuery = window.$ = $
window._ = _
window._.str = _str
window.Backbone = Backbone
window.URI = URI
window.XDate = XDate

Backbone.$ = window.$
Backbone.emulateHTTP = true
